var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLift(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 130 130",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;stroke:currentColor;stroke-miterlimit:10;stroke-width:2px;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Lift"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 45.65,
    y: 27,
    width: 32.34,
    height: 76.45
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 82.41,
    y: 27,
    width: 32.34,
    height: 76.45
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "32.42 57.87 16.25 57.87 24.34 43.17 32.42 57.87"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "32.42 68.16 16.25 68.16 24.34 82.87 32.42 68.16"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLift);
export default __webpack_public_path__ + "static/media/lift.23df680975819982e667ae7aafe7770c.svg";
export { ForwardRef as ReactComponent };